import {
  Box,
  Button,
  Flex,
  Grid,
  IconButton,
  Spacer,
  Modal,
  ModalOverlay,
  ModalContent,
  Center,
  Image,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Stack,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useBreakpointValue,
  useColorModeValue,
  FormLabel,
  Input,
  Spinner,
  HStack,
  VStack,
  TableContainer,
} from "@chakra-ui/react";
import Select from "react-select";
import {
  createColumnHelper,
  getCoreRowModel,
  getSortedRowModel,
  SortingState,
  useReactTable,
} from "@tanstack/react-table";
// Custom components
import Card from "components/Card/Card";
import { BsTrash, BsPencil } from "react-icons/bs";
import { BiNotification, BiSliderAlt } from "react-icons/bi";
import "./TableSector.css";

import * as React from "react";
// Assets
import useInventory from "hooks/use-inventory";
import { formatedDate, formatedDateBr } from "helpers/formated";
import useGeneral from "hooks/use-general";
import CategorySelect from "./SelectCategory";
import ModalHistoricInventory from "./ModalHistoricInventory";

type RowObj = {
  id: number;
  storeId: number;
  receivingSectorId: number;
  beginDate: string;
  endDate: string;
  userId: any;
  updatedAt: string;
  storeDescription: string;
  receivingSectorDescription: string;
};

const columnHelper = createColumnHelper<RowObj>();

// const columns = columnsDataCheck;
export default function TableInventory(props: { tableData: any }) {
  const { tableData } = props;
  const { data, getData, isFirstData, postData, deleteData, putData, loading } =
    useInventory();
  const { data: dataStore } = useGeneral();
  const parseValueSelect = (id: number) => {
    const valueOption = dataStore.find((item) => item.value === id);
    return valueOption;
  };
  const [sorting, setSorting] = React.useState<SortingState>([]);
  const textColor = useColorModeValue("black", "white");
  const textColorInvert = useColorModeValue("black", "black");

  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");
  const isMobile = useBreakpointValue({ base: true, md: false });
  const [isOpen, setIsOpen] = React.useState(false);
  const [centro, setCentro] = React.useState({ label: "", value: 0 });
  const [categoria, setCategoria] = React.useState("1");
  const [de, setDe] = React.useState("");
  const [ate, setAte] = React.useState("");
  const [idSelect, setIdSelect] = React.useState("");
  const [isOpenDeleted, setIsOpenDelete] = React.useState(false);

  const handleClose = () => {
    const isAdding = idSelect === "";
    setIdSelect("");
    if (isAdding) {
      setDe("");
      setAte("");
      setCategoria("1");
      setCentro({ label: "", value: 0 });
    }
    setIsOpen(false);
  };

  const handleOpen = () => {
    setDe("");
    setAte("");
    setCategoria("1");
    setCentro({ label: "", value: 0 });
    setIsOpen(true);
  };

  const handleCloseDelete = () => {
    setIsOpenDelete(false);
  };
  const handleSubmit = () => {
    debugger;
    const inventory = {
      storeId: centro?.value || 0,
      receivingSectorId: Number(categoria),
      beginDate: de,
      endDate: ate,
    };
    postData(inventory);
    handleClose();
  };

  const handleOpenDelete = () => {
    setIsOpenDelete(true);
  };
  const handleDelete = React.useCallback(() => {
    deleteData(Number(idSelect));
    handleCloseDelete();
  }, [deleteData, idSelect]);

  const handleUpdate = React.useCallback(() => {
    const inventory = {
      storeId: centro?.value || Number(centro) || 0,
      receivingSectorId: Number(categoria),
      beginDate: de,
      endDate: ate,
    };
    putData(inventory, idSelect);
    handleClose();
  }, [ate, categoria, centro, de, idSelect, putData]);

  const getInventoryIdEdit = React.useCallback(
    (id: any) => {
      setIdSelect(id);
      const user = data.find((item: { id: number }) => item.id === Number(id));
      
      const storeOption = parseValueSelect(user?.storeId);
      
      setCentro(storeOption || { label: "", value: user?.storeId || 0 });
      setCategoria(user?.receivingSectorId?.toString() || "1");
      setDe(formatedDate(user?.beginDate));
      setAte(formatedDate(user?.endDate));
      setIsOpen(true);
    },
    [data, dataStore]
  );

  const columns = [
    columnHelper.accessor("storeId", {
      id: "storeId",
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: "10px", lg: "12px" }}
          fontWeight="bold"
        >
          CENTRO
        </Text>
      ),
      cell: (info: any) => (
        <Flex align="center">
          <Text color={textColor} fontSize="sm">
            {info.getValue()}
          </Text>
        </Flex>
      ),
    }),
    columnHelper.accessor("receivingSectorDescription", {
      id: "receivingSectorDescription",
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: "10px", lg: "12px" }}
          fontWeight="bold"
        >
          CATEGORIA
        </Text>
      ),
      cell: (info) => (
        <Flex align="center">
          <Text color={textColor} fontSize="sm">
            {info.getValue()}
          </Text>
        </Flex>
      ),
    }),
    columnHelper.accessor("beginDate", {
      id: "beginDate",
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: "10px", lg: "12px" }}
          fontWeight="bold"
        >
          Período Inicial
        </Text>
      ),
      cell: (info) => (
        <Flex align="center">
          <Text justifyContent="space-between" color={textColor} fontSize="sm">
            {formatedDateBr(info.getValue())}
          </Text>
        </Flex>
      ),
    }),
    columnHelper.accessor("endDate", {
      id: "endDate",
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: "10px", lg: "12px" }}
          fontWeight="bold"
        >
          Período Final
        </Text>
      ),
      cell: (info) => (
        <Flex align="center">
          <Text justifyContent="space-between" color={textColor} fontSize="sm">
            {formatedDateBr(info.getValue())}
          </Text>
        </Flex>
      ),
    }),
    columnHelper.accessor("id", {
      id: "id",
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: "10px", lg: "12px" }}
          fontWeight="bold"
        >
          Ação
        </Text>
      ),
      cell: (info) => (
        <Flex justifyContent="space-between" alignItems="center">
          <Flex>
            <Box pr={3}>
              <IconButton
                icon={<BsTrash />}
                aria-label="Excluir"
                variant="outline"
                size="sm"
                onClick={() => {
                  handleOpenDelete();
                  setIdSelect(info.getValue().toString());
                }}
                colorScheme="red"
              />
            </Box>

            <IconButton
              icon={<BsPencil />}
              aria-label="Editar"
              variant="outline"
              size="sm"
              colorScheme="teal"
              onClick={() => {
                getInventoryIdEdit(info.getValue().toString());
              }}
            />
          </Flex>
        </Flex>
      ),
    }),
  ];
  // const [data, setData] = React.useState(() => [...defaultData]);
  const table = useReactTable({
    data,
    columns,
    state: {
      sorting,
    },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    debugTable: true,
  });

  React.useEffect(() => {
    isFirstData && getData();
  });
  return (
    <Card
      flexDirection="column"
      w="100%"
      px="0px"
      overflowX={{ sm: "scroll", lg: "hidden" }}
    >
      <Flex>
        {"\u00A0"}
        {"\u00A0"}
        <ModalHistoricInventory />
        <Spacer />
      </Flex>
      <Flex px="10px" justifyContent="space-between" align="center">
        <Text
          color={textColor}
          fontSize="22px"
          fontWeight="700"
          lineHeight="100%"
        ></Text>

        {/* <Menu /> */}
        <Stack direction={{ base: "column", md: "row" }} spacing="34px" p={6}>
          <Button colorScheme="green" variant="outline" onClick={handleOpen}>
            Adicionar
          </Button>
        </Stack>
      </Flex>
      <Modal isOpen={isOpenDeleted} onClose={handleCloseDelete}>
        <ModalOverlay />
        <ModalContent>
          <ModalBody>
            <Center>
              <Image
                width="80%"
                src="https://cdn.dribbble.com/users/592004/screenshots/2953817/media/ee885c68f4e39db8c72e3bbbaeca454f.gif"
              />
            </Center>

            <Center>
              <h1>Deseja realmente apagar esse registro?</h1>
            </Center>
            <Center>Esta ação é irreversível.</Center>
          </ModalBody>
          <ModalFooter>
            <Flex justifyContent="center" width="100%">
              <Button variant="ghost" onClick={handleCloseDelete}>
                Cancelar
              </Button>
              <Button colorScheme="red" mr={3} onClick={handleDelete}>
                Apagar
              </Button>
            </Flex>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Modal isOpen={isOpen} onClose={handleClose} size="md">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader
            paddingTop={2}
            paddingBottom={2}
            paddingLeft={4}
            paddingRight={4}
            textColor={"gray.200"}
            background={"#1d5840"}
            borderTopLeftRadius={5}
            borderTopRightRadius={5}
            borderBottom="3px solid #ECC94B"
          >
            <Flex>
              <Box p={2}>
                <BiSliderAlt />
              </Box>
              <Box p={2} pt={1} w={1200}>
                {idSelect !== "" ? (
                  <>Editar Inventário</>
                ) : (
                  <> Adicionar Inventário</>
                )}
              </Box>
            </Flex>
          </ModalHeader>
          <ModalCloseButton color="white" />
          <ModalBody>
            <Box maxW={480} flex={{ base: "1", md: "0 0 300px" }} pb={6}>
              <Flex>
                <VStack></VStack>
                <Box pl={2} pr={2}>
                  <Select
                    key={`store-select-${idSelect}`}
                    onChange={setCentro}
                    value={centro}
                    name="colors"
                    options={dataStore}
                    isDisabled={idSelect !== ""}
                    theme={(theme: { colors: any }) => ({
                      ...theme,
                      borderRadius: 0,
                      colors: {
                        ...theme.colors,
                        text: "#6EB680",
                        font: "#6EB680",
                        primary25: "#6EB680",
                        primary: "#6EB680",
                        neutral80: "black",
                        color: "black",
                      },
                    })}
                    styles={{
                      control: (provided: any) => ({
                        ...provided,
                        backgroundColor: "white",
                        borderColor: "black",
                        width: isMobile ? "150px" : "200px",
                      }),
                      option: (provided: any, state: { isSelected: any }) => ({
                        ...provided,
                        borderBottom: "1px dotted pink",
                        color: state.isSelected ? "black" : "black",
                        width: isMobile ? "150px" : "200px",
                        padding: 20,
                      }),
                    }}
                    classNamePrefix="select"
                  />
                </Box>
                <CategorySelect
                  key={`category-select-${idSelect}`}
                  categoria={categoria}
                  onChangeCategoria={setCategoria}
                  isDisabled={idSelect !== ""}
                />
              </Flex>
            </Box>
            <Box maxW={480} flex={{ base: "1", md: "0 0 300px" }} pb={6}>
              <Flex>
                <Box pl={2} pr={2}>
                  <FormLabel fontWeight={700}>De: </FormLabel>
                  <Input
                    type="date"
                    w={{ base: 150, md: 190 }}
                    value={de}
                    color={textColor}
                    onChange={(e) => setDe(e.target.value)}
                  />
                </Box>
                <Box>
                  <FormLabel fontWeight={700}>Ate: </FormLabel>
                  <Input
                    type="date"
                    w={{ base: 150, md: 190 }}
                    value={ate}
                    color={textColor}
                    onChange={(e) => {
                      setAte(e.target.value);
                    }}
                  />
                </Box>
              </Flex>
            </Box>
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" onClick={handleClose}>
              Fechar
            </Button>
            <Button
              colorScheme="green"
              ml={3}
              isDisabled={de === "" || ate === "" || centro?.value === 0}
              onClick={idSelect !== "" ? handleUpdate : handleSubmit}
            >
              Salvar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Flex justify="flex-end"></Flex>
      {loading ? (
        <>
          <Box>
            <Center>
              <HStack>
                <Spinner />
                <br></br>
                <Stack direction="column" align="center">
                  <span>Buscando Dados Aguarde...</span>
                </Stack>
              </HStack>
            </Center>
          </Box>
        </>
      ) : isMobile ? (
        // Exibir os cards em versões mobile
        <Box overflowX={{ base: "auto", md: "visible" }} maxH="400px">
          <Grid
            templateColumns="repeat(auto-fit, minmax(200px, 1fr))"
            gap={4}
            p={4}
          >
            {data.map((item: any) => (
              <Flex key={item.code} direction="row">
                <Box
                  borderWidth="3px"
                  borderRadius="md"
                  p={4}
                  boxShadow="base"
                  _hover={{ boxShadow: "xl" }}
                  flex="1"
                >
                  <Stack spacing={2}>
                    <Box as="strong">
                      <Flex>
                        <Text color="gray.400">{item?.storeId} </Text>
                        <Text>- {item?.storeDescription}</Text>
                      </Flex>
                    </Box>
                    <Box>
                      <BiNotification />
                      Categoria: {item?.receivingSectorDescription}
                    </Box>
                    <Box>De: {formatedDateBr(item?.beginDate)}</Box>
                    <Box>Ate: {formatedDateBr(item?.endDate)}</Box>
                    <hr></hr>
                    <Flex justifyContent="space-between" alignItems="center">
                      <Flex>
                        <Box pr={3}>
                          <IconButton
                            icon={<BsTrash />}
                            aria-label="Excluir"
                            variant="outline"
                            size="sm"
                            colorScheme="red"
                            onClick={() => {
                              handleOpenDelete();
                              setIdSelect(item?.id);
                            }}
                          />
                        </Box>

                        <IconButton
                          icon={<BsPencil />}
                          aria-label="Editar"
                          variant="outline"
                          size="sm"
                          colorScheme="teal"
                          onClick={() => {
                            getInventoryIdEdit(item?.id);
                          }}
                        />
                      </Flex>
                    </Flex>
                  </Stack>
                </Box>
              </Flex>
            ))}
          </Grid>
        </Box>
      ) : (
        // Exibir a tabela em versões desktop
        <Box overflowX="auto">
          <Box>
            <TableContainer>
              <Table
                className="custom-table"
                variant="simple"
                color="gray.500"
                mb="24px"
                mt="12px"
              >
                <Thead>
                  <Tr>
                    <Th
                      color={textColorInvert}
                      textAlign="center"
                      fontWeight="bold"
                    >
                      CENTRO
                    </Th>
                    <Th
                      color={textColorInvert}
                      textAlign="center"
                      fontWeight="bold"
                    >
                      CATEGORIA
                    </Th>
                    <Th
                      color={textColorInvert}
                      textAlign="center"
                      fontWeight="bold"
                    >
                      PERÍODO INICIAL
                    </Th>
                    <Th
                      color={textColorInvert}
                      textAlign="center"
                      fontWeight="bold"
                    >
                      PERÍODO FINAL
                    </Th>
                    <Th
                      color={textColorInvert}
                      textAlign="center"
                      fontWeight="bold"
                      textTransform="uppercase"
                    >
                      Ação
                    </Th>
                  </Tr>
                </Thead>

                <Tbody>
                  {data.map((item) => (
                    <Tr>
                      <Td color={textColor} scope="row">
                        {" "}
                        {item.storeId} - {item.storeDescription}
                      </Td>
                      <Td color={textColor} scope="row" textAlign="center">
                        {item?.receivingSectorDescription}
                      </Td>
                      <Td color={textColor} scope="row" textAlign="center">
                        {formatedDateBr(item?.beginDate)}
                      </Td>
                      <Td color={textColor} scope="row" textAlign="center">
                        {formatedDateBr(item?.endDate)}
                      </Td>

                      <Td textAlign="center">
                        {" "}
                        <Center>
                          <Box pr={3}>
                            <IconButton
                              icon={<BsTrash />}
                              aria-label="Excluir"
                              variant="outline"
                              size="sm"
                              colorScheme="red"
                              onClick={() => {
                                handleOpenDelete();
                                setIdSelect(item?.id);
                              }}
                            />
                          </Box>

                          <IconButton
                            icon={<BsPencil />}
                            aria-label="Editar"
                            variant="outline"
                            size="sm"
                            colorScheme="teal"
                            onClick={() => {
                              getInventoryIdEdit(item?.id);
                            }}
                          />
                        </Center>
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          </Box>
        </Box>
      )}
    </Card>
  );
}
